module.exports = __webpack_public_path__ + "static/media/ic_scroll_right.03f5afbc.svg";